export const LIST_TRANSACTIONS_REQUEST = "LIST_TRANSACTIONS_REQUEST";
export const LIST_TRANSACTIONS_SUCCESS = "LIST_TRANSACTIONS_SUCCESS";
export const LIST_TRANSACTIONS_FAIL = "LIST_TRANSACTIONS_FAIL";
